import React from "react";
import { Link } from "react-router-dom";
import "./Footer.scss";

const Footer = () => {
  return (
    <div className="container-fluid footer-navigation">
      <div className="row justify-content-center">
        <div className="col-11">
          <div className="row justify-content-center">
            <div className="col-md-6 left-half">
              <div className="row links">
                {/* <div className="col-4">
                  <p>Follow Us</p>
                  <ul>
                    <li>
                      <a href="https://www.facebook.com/PacificOutdoorLiving/">
                        Facebook
                      </a>
                    </li>
                    <li>
                      <a href="https://twitter.com/pacificoutdoor?lang=en">
                        Twitter
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/pacificoutdoorliving/?hl=en">
                        Instagram
                      </a>
                    </li>
                    <li>
                      <a href="https://www.pinterest.ph/pacificoutdoor/">
                        Pinterest
                      </a>
                    </li>
                  </ul>
                </div> */}
                <div className="col-5">
                  {/* <p>Explore</p> */}
                  <ul>
                    <li>
                      <Link to="/about-us/financing">Financing</Link>
                    </li>
                    <li>
                      <Link to="/reviews">Reviews</Link>
                    </li>
                    <li>
                      <Link to="/gallery">Gallery</Link>
                    </li>
                    <li>
                      <Link to="/contact-us">Contact</Link>
                    </li>
                    <li>
                      <Link to="/about-us/service-areas">Service Areas</Link>
                    </li>
                    <li>
                      <Link to="/careers">Careers</Link>
                    </li>
                    <li style={{ visibility: "hidden" }}>
                      <Link to="/thank-you-org">Hidden</Link>
                    </li>
                    <li style={{ visibility: "hidden" }}>
                      <Link to="/thank-you-ppc">Hidden</Link>
                    </li>
                    <li style={{ visibility: "hidden" }}>
                      <Link to="/404">Hidden</Link>
                    </li>
                    <li style={{ visibility: "hidden" }}>
                      <Link to="/payments">Hidden</Link>
                    </li>
                  </ul>
                </div>
                <div className="col-5">
                  {/* <p>About</p> */}
                  <ul>
                    <li>
                      <Link to="/blog/page/1">Blog</Link>
                    </li>
                    <li>
                      <Link to="/terms-and-conditions">Terms & Conditions</Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">Privacy</Link>
                    </li>
                    <li>
                      <Link to="/about-us">About Us</Link>
                    </li>
                    <li>
                      <Link to="/faq">FAQ</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6 right-half">
              <div className="row justify-content-center contact-details">
                <div className="col-md-6">
                  <Link to="/contact-us">
                    <button className="button-main button-blue transition-3">
                      Schedule a call
                    </button>
                  </Link>
                  <p className="mt-5">
                    Phone: <a href="tel:818-275-8613">(818) 275-8613</a>
                    <br />
                    <br />
                    OFFICE AND SHOWROOM:
                    <br />
                    8309 Tujunga Ave Ste. 101
                    <br />
                    Sun Valley, CA 91352, USA
                    <br />
                    <br />
                    <br />
                    HOURS:
                    <br /> Monday - Friday: 9:00am - 6:00pm
                    <br />
                    Saturday: 9:00am - 5:00pm
                    <br />
                    Sunday: Closed
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-center rights">
            <div className="col-12 col-md-6 copyright">
              &copy; {new Date().getFullYear()} Pacific Pavingstone. All Rights
              Reserved.
            </div>
            <div className="col-12 col-md-6 license">LICENSE: LIC #715731</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
